import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Integration } from '../types/integration';

interface IntegrationModalProps {
  integration: Integration;
  isOpen: boolean;
  onClose: () => void;
}

export const IntegrationModal: React.FC<IntegrationModalProps> = ({
  integration,
  isOpen,
  onClose,
}) => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    onClose();
    if (integration.setupUrl) {
      navigate(integration.setupUrl);
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="h6">{integration.name}</Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography color="text.secondary" paragraph>
          {integration.description}
        </Typography>

        <Typography variant="h6" sx={{ mb: 2 }}>
          Key Features
        </Typography>

        <List>
          {integration.features.map((feature, index) => (
            <ListItem key={index}>
              <ListItemIcon>
                {/* simple bullet checkmark via typography to avoid icon fallbacks */}
                <Typography component="span" color="#4CAF50">
                  •
                </Typography>
              </ListItemIcon>
              <ListItemText primary={feature} />
            </ListItem>
          ))}
        </List>
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <Button onClick={onClose} variant="outlined">
          Close
        </Button>
        {integration.status === 'available' && integration.setupUrl && (
          <Button variant="contained" onClick={handleGetStarted}>
            Get Started
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
